// START Array.prototype.from polyfill, bc not supported by IE
if (!Array.from) {
  Array.from = (function () {
    var toStr = Object.prototype.toString;
    var isCallable = function (fn) {
      return typeof fn === 'function' || toStr.call(fn) === '[object Function]';
    };
    var toInteger = function (value) {
      var number = Number(value);
      if (isNaN(number)) { return 0; }
      if (number === 0 || !isFinite(number)) { return number; }
      return (number > 0 ? 1 : -1) * Math.floor(Math.abs(number));
    };
    var maxSafeInteger = Math.pow(2, 53) - 1;
    var toLength = function (value) {
      var len = toInteger(value);
      return Math.min(Math.max(len, 0), maxSafeInteger);
    };

    // The length property of the from method is 1.
    return function from(arrayLike/*, mapFn, thisArg */) {
      // 1. Let C be the this value.
      var C = this;

      // 2. Let items be ToObject(arrayLike).
      var items = Object(arrayLike);

      // 3. ReturnIfAbrupt(items).
      if (arrayLike == null) {
        throw new TypeError('Array.from requires an array-like object - not null or undefined');
      }

      // 4. If mapfn is undefined, then let mapping be false.
      var mapFn = arguments.length > 1 ? arguments[1] : void undefined;
      var T;
      if (typeof mapFn !== 'undefined') {
        // 5. else
        // 5. a If IsCallable(mapfn) is false, throw a TypeError exception.
        if (!isCallable(mapFn)) {
          throw new TypeError('Array.from: when provided, the second argument must be a function');
        }

        // 5. b. If thisArg was supplied, let T be thisArg; else let T be undefined.
        if (arguments.length > 2) {
          T = arguments[2];
        }
      }

      // 10. Let lenValue be Get(items, "length").
      // 11. Let len be ToLength(lenValue).
      var len = toLength(items.length);

      // 13. If IsConstructor(C) is true, then
      // 13. a. Let A be the result of calling the [[Construct]] internal method
      // of C with an argument list containing the single item len.
      // 14. a. Else, Let A be ArrayCreate(len).
      var A = isCallable(C) ? Object(new C(len)) : new Array(len);

      // 16. Let k be 0.
      var k = 0;
      // 17. Repeat, while k < len… (also steps a - h)
      var kValue;
      while (k < len) {
        kValue = items[k];
        if (mapFn) {
          A[k] = typeof T === 'undefined' ? mapFn(kValue, k) : mapFn.call(T, kValue, k);
        } else {
          A[k] = kValue;
        }
        k += 1;
      }
      // 18. Let putStatus be Put(A, "length", len, true).
      A.length = len;
      // 20. Return A.
      return A;
    };
  }());
}
// END Array.prototype.from polyfill, bc not supported by IE

import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Document, Outline, Page } from 'react-pdf/dist/entry.webpack'
import axios from 'axios'
import { saveAs } from 'file-saver'
import printJS from 'print-js'

export default class PdfViewer extends React.Component {
  constructor(props) {
    super(props)

    // Methods for Pdf navigation
    this.goToPage = this.goToPage.bind(this)
    this.goToPrevPage = this.goToPrevPage.bind(this)
    this.goToNextPage = this.goToNextPage.bind(this)
    this.jumpToPage = this.jumpToPage.bind(this)
    this.goToFirstPage = this.goToFirstPage.bind(this)
    this.goToLastPage = this.goToLastPage.bind(this)
    this.hideNavigationButtons = this.hideNavigationButtons.bind(this)
    this.showNavigationButtons = this.showNavigationButtons.bind(this)

    // Methods for Pdf pages views
    this.isFirstPage = this.isFirstPage.bind(this)
    this.isLastPage = this.isLastPage.bind(this)
    this.isPageViewed = this.isPageViewed.bind(this)
    this.areAllPagesViewed = this.areAllPagesViewed.bind(this)
    this.addViewToContractDocumentPage = this.addViewToContractDocumentPage.bind(this)

    // Methods for Pdf pages initials
    this.isPageInitialed = this.isPageInitialed.bind(this)
    this.handleAddAllInitialsClick = this.handleAddAllInitialsClick.bind(this)
    this.handleAddInitialsClick = this.handleAddInitialsClick.bind(this)
    this.getDataForContractDocumentPageInitial = this.getDataForContractDocumentPageInitial.bind(this)
    this.shouldDisplayVirtualInitials = this.shouldDisplayVirtualInitials.bind(this)
    this.areAllPagesInitialed = this.areAllPagesInitialed.bind(this)

    // Methods for Pdf accept_terms
    this.acceptTermsForDocument = this.props.acceptTermsForDocument
    this.handlePdfPageMouseOver = this.handlePdfPageMouseOver.bind(this)
    this.handleAcceptTermsClick = this.handleAcceptTermsClick.bind(this)
    // closePdfViewer is a callback function from parent component ProjectDocuments
    this.closePdfViewer = this.props.closePdfViewer

    // Methods for contract document signature
    this.isSignAction = this.isSignAction.bind(this)
    this.acceptContractIfAllPagesRead = this.acceptContractIfAllPagesRead.bind(this)
    this.startSignatureIfAllPagesInitialed = this.startSignatureIfAllPagesInitialed.bind(this)

    // Methods for Pdf pages annotations
    this.isAnnotateAction = this.isAnnotateAction.bind(this)
    this.handleAnnotateClick = this.handleAnnotateClick.bind(this)
    this.isPageAnnotated = this.isPageAnnotated.bind(this)
    this.getDataForContractDocumentPageAnnotation = this.getDataForContractDocumentPageAnnotation.bind(this)
    this.getPageAnnotation = this.getPageAnnotation.bind(this)
    this.handleAnnotateFieldChange = this.handleAnnotateFieldChange.bind(this)

    // Misc methods
    this.onDocumentLoadSuccess = this.onDocumentLoadSuccess.bind(this)
    this.handleDownloadPdfClick = this.handleDownloadPdfClick.bind(this)
    this.handlePrintPdfClick = this.handlePrintPdfClick.bind(this)

    this.state = {
      displayAllPages: this.props.displayAllPages || false,
      numPages: null,
      pageNumber: 1,
      userContractDocumentPagesViews: this.props.userContractDocumentPagesViews,
      userContractDocumentPagesInitials: this.props.userContractDocumentPagesInitials,
      userContractDocumentPagesAnnotations: this.props.userContractDocumentPagesAnnotations,
      areAllPagesScrolled: !this.props.scrollAllPagesToAcceptTerms,
      selectedProjectDocumentId: this.props.selectedProjectDocumentId,
      isLoading: false
    }
  }

  /***** BEGIN Methods for Pdf navigation *****/
  goToPage(pageNb) {
    this.hideNavigationButtons()
    this.setState({ pageNumber: pageNb })
  }

  goToPrevPage(event) {
    this.hideNavigationButtons()
    this.setState({ pageNumber: this.state.pageNumber - 1 })
    // prevent default behavior of click on button tag which is to reload the html page/document
    event.preventDefault()
  }

  goToNextPage(event) {
    this.hideNavigationButtons()
    this.setState({ pageNumber: this.state.pageNumber + 1 })
    // prevent default behavior of click on button tag which is to reload the html page/document
    event.preventDefault()
  }

  jumpToPage(event) {
    let targetedPage = Number(event.target.value)
    if (targetedPage > 0 && targetedPage <= this.state.numPages) {
      this.setState({ pageNumber: targetedPage })
    }
  }

  goToFirstPage(event) {
    this.hideNavigationButtons()
    this.setState({ pageNumber: 1 })
    // prevent default behavior of click on button tag which is to reload the html page/document
    event.preventDefault()
  }

  goToLastPage(event) {
    this.hideNavigationButtons()
    this.setState({ pageNumber: this.state.numPages })
    // prevent default behavior of click on button tag which is to reload the html page/document
    event.preventDefault()
  }

  // Hide previous, next page and inital buttons while request is processing
  hideNavigationButtons() {
    $('#next-page-button').hide()
    $('#previous-page-button').hide()
    $('#add-initials-button').hide()
  }

  // Show previous, next page and inital buttons
  showNavigationButtons() {
    $('#next-page-button').show()
    $('#previous-page-button').show()
    $('#add-initials-button').show()
  }
  /***** END Methods for Pdf navigation *****/

  /***** BEGIN Methods for Pdf pages views *****/
  isFirstPage() {
    return this.state.pageNumber == 1
  }

  isLastPage() {
    return this.state.pageNumber == this.state.numPages
  }

  isPageViewed(pageNumber) {
    let pageViewed = false

    if (this.state.userContractDocumentPagesViews != undefined) {
      if (Object.keys(this.state.userContractDocumentPagesViews).length > 0 &&
        this.state.userContractDocumentPagesViews[pageNumber] == true) {
        pageViewed = true
      }
    }
    return pageViewed
  }

  // Checks whether user viewed all contractDocument pages
  areAllPagesViewed() {
    return (this.state.userContractDocumentPagesViews != undefined && Object.keys(this.state.userContractDocumentPagesViews).length == this.state.numPages)
  }

  // Call api to add view to ContractDocument current page if page not viewed
  addViewToContractDocumentPage() {
    const { pageNumber, userContractDocumentPagesViews } = this.state
    const { i18n } = this.props

    if (!this.isPageViewed(pageNumber)) {
      this.hideNavigationButtons()
      axios.post('/api/v1/contract_document_page_initials', this.getDataForContractDocumentPageInitial())
        .then((response) => {
          this.showNavigationButtons()
          if (Object.entries(response.data.userContractDocumentPagesViews).length === 0) {
            alert(i18n['error_occurred_during_request'])
          } else {
            this.setState({ userContractDocumentPagesViews: response.data.userContractDocumentPagesViews })
          }
        })
        .catch((error) => {
          console.log(error)
          alert(i18n['error_occurred_during_request'])
        })
    }
  }
  /***** END Methods for Pdf pages views *****/

  /***** BEGIN Methods for Pdf pages initials *****/
  isPageInitialed(pageNumber) {
    let pageInitialed = false
    if (Object.keys(this.state.userContractDocumentPagesInitials).length > 0
      && this.state.userContractDocumentPagesInitials[pageNumber] == true) {
      pageInitialed = true
    }
    return pageInitialed
  }

  // Handle click on addAllInitials button: call api Api::V1::ContractDocumentPageInitialsController#create_all
  handleAddAllInitialsClick(event) {
    const { contractDocument, i18n } = this.props
    let pageNumber = 1

    this.hideNavigationButtons()
    axios.post(`/api/v1/contract_document_page_initials/${contractDocument.id}/create_all`, this.getDataForContractDocumentPageInitial())
      .then((response) => {
        this.showNavigationButtons()
        this.setState({
          userContractDocumentPagesInitials: response.data.userContractDocumentPagesInitials,
          pageNumber: this.state.numPages
        })
      })
      .catch((error) => {
        console.log(error)
        alert(i18n['error_occurred_during_request'])
      })
    // prevent default behavior of click on button tag which is to reload the html page/document
    event.preventDefault()
  }

  // Handle click on addInitials button: call api to set ContractDocumentPageInitial#initialed_at
  handleAddInitialsClick(event) {
    const { contractDocument, i18n } = this.props
    let pageNumber = 1

    this.hideNavigationButtons()
    axios.patch(`/api/v1/contract_document_page_initials/${contractDocument.id}`, this.getDataForContractDocumentPageInitial())
      .then((response) => {
        this.showNavigationButtons()
        pageNumber = (this.isLastPage() ? this.state.numPages : (this.state.pageNumber + 1))
        this.setState({
          userContractDocumentPagesInitials: response.data.userContractDocumentPagesInitials,
          pageNumber: pageNumber
        })
      })
      .catch((error) => {
        console.log(error)
        alert(i18n['error_occurred_during_request'])
      })
    // prevent default behavior of click on button tag which is to reload the html page/document
    event.preventDefault()
  }

  getDataForContractDocumentPageInitial() {
    const { authenticityToken, contractDocument, user, action } = this.props
    const { pageNumber } = this.state

    return {
      authenticity_token: authenticityToken,
      // Returns number of pages in contract_document pdf file
      uploaded_image_pages_count: this.state.numPages,
      contract_document_page_initial: {
        contract_document_id: contractDocument.id,
        personable_id: user.id,
        personable_type: user.type,
        page_number: pageNumber
      }
    }
  }

  // Returns boolean whether we should or not display virtual initials
  shouldDisplayVirtualInitials(pageNumber) {
    let displayVirtualInitials = false
    if (Object.keys(this.state.userContractDocumentPagesInitials).length > 0) {
      if (this.props.userContractDocumentPagesInitials[pageNumber] == undefined
        && this.state.userContractDocumentPagesInitials[pageNumber] == true) {
        displayVirtualInitials = true
      }
    }
    return displayVirtualInitials
  }

  // Checks whether user initialed all contractDocument pages
  areAllPagesInitialed() {
    return Object.keys(this.state.userContractDocumentPagesInitials).length == this.state.numPages
  }
  /***** END Methods for Pdf pages initials *****/

  /***** BEGIN Methods for Pdf accept_terms *****/
  // Step project_description: accept document terms and hide PdfViewer
  handleAcceptTermsClick(event) {
    const { user, i18n } = this.props
    const { selectedProjectDocumentId } = this.state

    axios.patch(`/api/v1/documents_projects/${selectedProjectDocumentId}/accept_terms?user_id=${user.id}`, {})
      .then((response) => {
        this.acceptTermsForDocument(selectedProjectDocumentId)
      })
      .catch((error) => {
        console.log(error)
        alert(i18n['error_occurred_during_request'])
      })
    this.closePdfViewer()
    // prevent default behavior of click on button tag which is to reload the html page/document
    event.preventDefault()
  }

  // If all pages are scrolled, display button to accept terms
  handlePdfPageMouseOver(page, numPages) {
    if (!this.state.areAllPagesScrolled && numPages == page.pageIndex + 1) {
      this.setState({ areAllPagesScrolled: true })
    }
  }
  /***** END Methods for Pdf accept_terms *****/

  /***** BEGIN Methods for contract document signature *****/
  isSignAction() {
    const { action } = this.props
    return action == 'sign'
  }

  // If action is read and all pages are read, display check box and button to accept contract
  acceptContractIfAllPagesRead() {
    if (this.areAllPagesViewed()) {
      $("#contract-good-agreement").show()
    } else {
      $("#contract-good-agreement").hide()
    }
  }

  // If action is sign and all pages are initialed, display fields for user good_agreement and start signature
  startSignatureIfAllPagesInitialed() {
    if (this.areAllPagesInitialed()) {
      $("#contract-good-agreement-signature").show()
      $(".k-form__actions input[type='submit']").show()
    } else {
      $("#contract-good-agreement-signature").hide()
      $(".k-form__actions input[type='submit']").hide()
    }
  }
  /***** END Methods for contract document signature *****/

  /***** BEGIN Methods for Pdf pages annotations *****/
  isAnnotateAction() {
    const { action } = this.props
    return action == 'annotate'
  }

  // Save content of page annotation when user click on button
  handleAnnotateClick(event) {
    const { pageNumber, userContractDocumentPagesAnnotations } = this.state
    const { contractDocument, i18n } = this.props
    let url = '/api/v1/contract_document_page_annotations'

    this.hideNavigationButtons()
    if (this.isPageAnnotated(pageNumber)) {
      url += `/${contractDocument.id}`
      this.queryMipiseApi('patch', url, this.getDataForContractDocumentPageAnnotation())
    } else {
      this.queryMipiseApi('post', url, this.getDataForContractDocumentPageAnnotation())
    }
    // prevent default behavior of click on button tag which is to reload the html page/document
    event.preventDefault()
    this.setState({ isLoading: true })
  }

  // Query to send to Mipise API
  queryMipiseApi(method, url, data) {
    const { i18n } = this.props

    axios({ method: method, url: url, data: data })
      .then((response) => {
        this.showNavigationButtons()
        if (Object.entries(response.data.userContractDocumentPagesAnnotations).length === 0) {
          alert(i18n['error_occurred_during_request'])
        } else {
          $('#contract_document_validation_message').val(response.data.validationMessage)
          this.setState({ userContractDocumentPagesAnnotations: response.data.userContractDocumentPagesAnnotations })
          let location = window.location.href.split("?")[0] += `?page=${this.state.pageNumber}`
          window.location.href = `${location}`;
        }
      })
      .catch((error) => {
        alert(i18n['error_occurred_during_request'])
      })
  }

  isPageAnnotated(pageNumber) {
    const { userContractDocumentPagesAnnotations } = this.state
    let pageAnnotated = false

    if (userContractDocumentPagesAnnotations != undefined) {
      if (Object.keys(userContractDocumentPagesAnnotations).length > 0 &&
        userContractDocumentPagesAnnotations.hasOwnProperty(pageNumber)) {
        if (userContractDocumentPagesAnnotations[pageNumber].persisted == true) {
          pageAnnotated = true
        }
      }
    }
    return pageAnnotated
  }

  getDataForContractDocumentPageAnnotation() {
    const { authenticityToken, contractDocument, user, action } = this.props
    const { pageNumber } = this.state
    let comment = $('#contract_document_page_annotation_comment').val() || ''

    return {
      authenticity_token: authenticityToken,
      contract_document_page_annotation: {
        contract_document_id: contractDocument.id,
        page_number: pageNumber,
        comment: comment
      }
    }
  }

  getPageAnnotation(pageNumber) {
    const { userContractDocumentPagesAnnotations } = this.state
    let comment = ''

    if (userContractDocumentPagesAnnotations.hasOwnProperty(pageNumber) &&
      userContractDocumentPagesAnnotations[pageNumber].hasOwnProperty('comment')) {
      comment = userContractDocumentPagesAnnotations[pageNumber].comment
    }
    return comment
  }

  handleAnnotateFieldChange(event) {
    const { pageNumber, userContractDocumentPagesAnnotations } = this.state
    let persisted = false;
    if (userContractDocumentPagesAnnotations.hasOwnProperty(pageNumber)) {
      // persisted: false because it's not persisted on the server yet
      if (userContractDocumentPagesAnnotations[pageNumber].hasOwnProperty('persisted') &&
        userContractDocumentPagesAnnotations[pageNumber].persisted == true) {
        persisted = true
      }
    }
    userContractDocumentPagesAnnotations[pageNumber] = { persisted: persisted, comment: event.target.value }
    this.setState({ userContractDocumentPagesAnnotations: userContractDocumentPagesAnnotations });
  }
  /***** END Methods for Pdf pages annotations *****/

  /***** BEGIN Misc methods *****/
  onDocumentLoadSuccess({ numPages }) {
    const { action, contractDocument } = this.props
    const readAndSignActions = ['read', 'sign']
    const unauthorizedContractDocumentStates = ['contract_document_signed']

    // Go back to latest page viewed or initialed
    // unless action == annotate OR contractDocument.state == contract_document_signed
    if (readAndSignActions.includes(action) &&
      this.state.numPages === null &&
      Object.keys(this.state.userContractDocumentPagesInitials).length > 0 &&
      !unauthorizedContractDocumentStates.includes(contractDocument.state)) {
      for (var i = 1; i <= numPages; i++) {
        if (i === numPages || this.state.userContractDocumentPagesInitials[i] !== true) {
          this.goToPage(i)
          break
        }
      }
    }

    this.setState({ numPages })
    readAndSignActions.includes(action) && this.startSignatureIfAllPagesInitialed()
  }

  componentDidUpdate(prevProps, prevState) {
    const { action } = this.props
    const readAndSignActions = ['read', 'sign']
    const allowedActions = ['read', 'sign', 'annotate']
    allowedActions.includes(action) && this.showNavigationButtons()
    // After component is rendered check if addViewToContractDocumentPage for current_user
    readAndSignActions.includes(action) && this.addViewToContractDocumentPage()
    // If action is read and all pages are read, display check box and button to accept contract
    readAndSignActions.includes(action) && this.acceptContractIfAllPagesRead()
    // If action is sign and all pages are initialed, display fields for user good_agreement and start signature
    readAndSignActions.includes(action) && this.startSignatureIfAllPagesInitialed()
  }

  // Handle click on download pdf
  handleDownloadPdfClick(event) {
    const { contractDocument } = this.props
    fetch(contractDocument.pdfUrl)
      .then(res => res.blob())
      .then((blob) => {
        saveAs(blob, `${contractDocument.name}.pdf`);
      })
    // saveAs(contractDocument.pdfUrl, `${contractDocument.name}.pdf`)
    // prevent default behavior of click on button tag which is to reload the html page/document
    event.preventDefault()
  }

  // Handle click on print pdf
  handlePrintPdfClick(event) {
    const { contractDocument } = this.props
    printJS(contractDocument.pdfUrl)
    // prevent default behavior of click on button tag which is to reload the html page/document
    event.preventDefault()
  }
  /***** END Misc methods *****/

  componentDidMount() {
    let queryString = window.location.search;
    let urlParams = new URLSearchParams(queryString);
    let activePage = urlParams.get("page")
    if (!isNaN(parseInt(activePage))) {
      this.state.pageNumber = parseInt(activePage)
    };
  }

  /***** RENDER COMPONENT *****/
  render() {
    const { contractDocument, action, i18n, user, initialAllPagesAtOnce } = this.props
    const { displayAllPages, pageNumber, numPages, areAllPagesScrolled } = this.state

    return (
      <div className="PdfViewer">

        <div className="PdfViewer__container">

          <main className="PdfViewer__container__content">
            <Document
              file={contractDocument.pdfUrl}
              error={i18n['pdf_loading_failed']}
              loading={i18n['loading_pdf_progress']}
              noData={i18n['no_pdf_file_specified']}
              onLoadSuccess={this.onDocumentLoadSuccess}
            >
              <div className="PdfViewer__container__content__controls justify-content-center">
                <div className="PdfViewer__container__content__controls_pagination">
                  <form>
                    {!this.isFirstPage() &&
                      <button
                        id="first-page-button"
                        className="btn btn-sm"
                        onClick={this.goToFirstPage}
                      >
                        <i className="fa fa-step-backward" title={i18n["previous"]}></i>
                      </button>
                    }
                    {!this.isFirstPage() &&
                      <button
                        id="previous-page-button"
                        className="btn btn-sm mr-3"
                        onClick={this.goToPrevPage}
                      >
                        <i className="fa fa-arrow-left" title={i18n["previous"]}></i>
                      </button>
                    }
                    {i18n["page"]} <input type="text" placeholder={pageNumber} size="3" onChange={this.jumpToPage} /> {i18n["of"]} {numPages}
                    {!this.isLastPage() &&
                      <button
                        id="next-page-button"
                        className="btn btn-sm ml-3"
                        onClick={this.goToNextPage}
                      >
                        <i className="fa fa-arrow-right" title={i18n["next"]}></i>
                      </button>
                    }
                    {!this.isLastPage() &&
                      <button
                        id="last-page-button"
                        className="btn btn-sm"
                        onClick={this.goToLastPage}
                      >
                        <i className="fa fa-step-forward" title={i18n["next"]}></i>
                      </button>
                    }
                  </form>
                </div>
                <div>
                  <button
                    className="btn btn-sm mr-3"
                    id='download-button'
                    onClick={this.handleDownloadPdfClick}
                  >
                    <i className="fa fa-download" title={this.props.i18n['download']}></i>
                  </button>

                  <button
                    className="btn btn-sm mr-3"
                    id='print-button'
                    onClick={this.handlePrintPdfClick}
                  >
                    <i className="fa fa-print" title={this.props.i18n['print']}></i>
                  </button>
                </div>
              </div>
              <div className="PdfViewer__container__content__document">
                {(
                  displayAllPages
                    ? Array.from(
                      new Array(numPages),
                      (el, index) => (
                        <Page
                          key={`page_${index + 1}`}
                          pageNumber={index + 1}
                          onMouseOver={(event, page) => this.handlePdfPageMouseOver(page, numPages)}
                        />
                      ),
                    )
                    : (
                      <Page
                        pageNumber={pageNumber || 1}
                      />
                    )
                )}
                {this.isSignAction() && this.shouldDisplayVirtualInitials(pageNumber) &&
                  <div className="PdfViewer__container__content__initials ml-5">
                    <img src={user.initials} />
                  </div>
                }

                {this.isSignAction() && !this.isPageInitialed(pageNumber) &&
                  <div className="PdfViewer__container__content__initials ml-5">
                    {initialAllPagesAtOnce ? (
                      <button
                        className="btn btn-sm mr-3"
                        id='add-all-initials-button'
                        onClick={this.handleAddAllInitialsClick}
                      >
                        {this.props.i18n['add_all_initials']}
                      </button>
                    ) : (
                      <button
                        className="btn btn-sm mr-3"
                        id='add-initials-button'
                        onClick={this.handleAddInitialsClick}
                      >
                        {this.props.i18n['add_initials']}
                      </button>
                    )
                    }
                  </div>
                }
              </div>

              {displayAllPages ?
                ((!contractDocument.termsAccepted && areAllPagesScrolled) ? (
                  <div className="text-center mt-3">
                    <button
                      id='accept-terms-button'
                      className="btn btn-success btn-sm"
                      onClick={this.handleAcceptTermsClick}
                    >
                      {i18n['confirm_have_read_doc_and_join'].replace(/<DOC_TITLE>/g, contractDocument.title)}
                    </button>
                  </div>
                ) : (
                  <div className="text-center mt-3">
                    <button
                      id='close-pdf-viewer-button'
                      className="btn btn-success btn-sm"
                      onClick={this.closePdfViewer}
                    >
                      Fermer
                    </button>
                  </div>

                )) : (
                  <React.Fragment>
                    <div className="PdfViewer__container__content__controls">
                      <div className="PdfViewer__container__content__controls_pagination">
                        <form>
                          {!this.isFirstPage() &&
                            <button
                              id="first-page-button"
                              className="btn btn-sm"
                              onClick={this.goToFirstPage}
                            >
                              <i className="fa fa-step-backward" title={i18n["previous"]}></i>
                            </button>
                          }
                          {!this.isFirstPage() &&
                            <button
                              id="previous-page-button"
                              className="btn btn-sm mr-3"
                              onClick={this.goToPrevPage}
                            >
                              <i className="fa fa-arrow-left" title={i18n["previous"]}></i>
                            </button>
                          }
                          {i18n["page"]} <input type="text" placeholder={pageNumber} size="3" onChange={this.jumpToPage} /> {i18n["of"]} {numPages}
                          {!this.isLastPage() &&
                            <button
                              id="next-page-button"
                              className="btn btn-sm ml-3"
                              onClick={this.goToNextPage}
                            >
                              <i className="fa fa-arrow-right" title={i18n["next"]}></i>
                            </button>
                          }
                          {!this.isLastPage() &&
                            <button
                              id="last-page-button"
                              className="btn btn-sm"
                              onClick={this.goToLastPage}
                            >
                              <i className="fa fa-step-forward" title={i18n["next"]}></i>
                            </button>
                          }
                        </form>
                      </div>
                      <div>
                        <button
                          className="btn btn-sm mr-3"
                          id='download-button'
                          onClick={this.handleDownloadPdfClick}
                        >
                          <i className="fa fa-download" title={this.props.i18n['download']}></i>
                        </button>

                        <button
                          className="btn btn-sm mr-3"
                          id='print-button'
                          onClick={this.handlePrintPdfClick}
                        >
                          <i className="fa fa-print" title={this.props.i18n['print']}></i>
                        </button>
                      </div>
                    </div>

                    {this.isAnnotateAction() &&
                      <div className="PdfViewer__container__content__annotations">
                        <div className="form-group">
                          <label className="form-control-label" htmlFor="contract_document_page_annotation_comment">
                            {this.props.i18n['put_comment_here']}
                          </label>
                          <textarea
                            id="contract_document_page_annotation_comment"
                            className="form-control"
                            name="contract_document_page_annotation[comment]"
                            rows="5" cols="40"
                            value={this.getPageAnnotation(pageNumber)}
                            onChange={this.handleAnnotateFieldChange}
                            disabled={this.state.isLoading}
                          />
                        </div>
                        <div className="text-center">
                          <button
                            className="btn btn-primary"
                            id='annotate-button'
                            onClick={this.handleAnnotateClick}
                            disabled={this.state.isLoading}
                          >
                            {this.props.i18n['comment']}
                          </button>
                        </div>
                      </div>
                    }
                  </React.Fragment>
                )
              }
            </Document>
          </main>

        </div>

      </div>
    );
  }
}

// Typechecking With PropTypes https://reactjs.org/docs/typechecking-with-proptypes.html
PdfViewer.propTypes = {
  action: PropTypes.oneOf(['read', 'sign', 'accept_terms', 'annotate']).isRequired,
  closePdfViewer: PropTypes.func,
  contractDocument: PropTypes.object.isRequired,
  userContractDocumentPagesViews: PropTypes.object.isRequired
}



// WEBPACK FOOTER //
// ./app/frontend/packs/PdfViewer/PdfViewer.jsx